/* ZSportsTech — section-accordion.js
   Scoped to #sc-brfaq (Bat Repair · 09 FAQ). Single-open accordion.
   Maps to → assets/section-accordion.js in Shopify theme.
   ─────────────────────────────────────────────────── */
(function () {
  'use strict';

  var root = document.getElementById('sc-brfaq');
  if (!root) return;

  var rows = Array.prototype.slice.call(root.querySelectorAll('.faq-row'));
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setOpen(row, open) {
    var btn    = row.querySelector('.faq-row__q');
    var panel  = row.querySelector('.faq-row__a');
    var icon   = row.querySelector('.faq-row__icon');
    row.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', String(open));
    if (icon) icon.textContent = open ? '−' : '+';
    if (panel) {
      if (open) {
        panel.hidden = false;
        if (reduce) { panel.style.maxHeight = 'none'; }
        else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          panel.addEventListener('transitionend', function te() {
            if (row.classList.contains('is-open')) panel.style.maxHeight = 'none';
            panel.removeEventListener('transitionend', te);
          });
        }
      } else {
        if (reduce) { panel.style.maxHeight = ''; panel.hidden = true; }
        else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          void panel.offsetHeight; /* reflow */
          panel.style.maxHeight = '0px';
          panel.addEventListener('transitionend', function te() {
            if (!row.classList.contains('is-open')) panel.hidden = true;
            panel.removeEventListener('transitionend', te);
          });
        }
      }
    }
  }

  rows.forEach(function (row) {
    var btn = row.querySelector('.faq-row__q');
    if (!btn) return;
    /* initialise from is-open class */
    var startOpen = row.classList.contains('is-open');
    var panel = row.querySelector('.faq-row__a');
    if (panel && !startOpen) panel.hidden = true;
    if (panel && startOpen && !reduce) panel.style.maxHeight = 'none';
    btn.setAttribute('aria-expanded', String(startOpen));

    btn.addEventListener('click', function () {
      var open = row.classList.contains('is-open');
      /* single-open: close others */
      if (!open) rows.forEach(function (r) { if (r !== row) setOpen(r, false); });
      setOpen(row, !open);
    });
  });
}());
